import Raven from 'raven-js';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';

// props passed in when withErrorBoundary is called

// props that come from passing into withErrorBoundary and those added by
// withRouter
// children comes from withErrorBoundary rendering <WrappedComponent>
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    Raven.captureException(Error('Error boundary caught uncaught exception'), {
      extra: {
        message: error.message,
        boundaryName: this.props.boundaryName
      }
    });
  }
  render() {
    if (this.state.hasError) {
      const {
        boundaryName
      } = this.props;
      console.error('ErrorBoundary caught uncaught error', boundaryName);
      return null;
    }
    return this.props.children;
  }
}
export function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  const ErrorBoundaryWrapper = props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, errorBoundaryProps, {
    history: props.history,
    location: props.location,
    match: props.match,
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
  }));
  return withRouter(ErrorBoundaryWrapper);
}